// @ts-nocheck -- RARE-264 mechanical rename; type this file under RARE-265
import { CFormSwitch } from "@coreui/react-pro";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../contexts/auth-context";
import ColourChip from "../../Utility/Components/ColourChip";
import { SideSegment } from "../index";

const UserList = ({ segment: inSegment, onChange, children, ...props }) => {
  const [segment, setSegment] = useState({});
  const [customOpts, setCustomOpts] = useState([]);
  const [showMyLists, setShowMyLists] = useState(false);
  const {
    user: { id: userId },
  } = useContext(AuthContext);
  useEffect(() => {
    setSegment({ ...inSegment, strings: [] });
    if (inSegment.strings) {
      setCustomOpts(
        [...inSegment.strings]
          .filter((el) => {
            if (!showMyLists) {
              return true;
            }

            return el.userId === userId;
          })
          .sort((a, b) => {
            if (a.name > b.name) {
              return 1;
            } else if (a.name < b.name) {
              return -1;
            }
            return 0;
          })
          .map((el) => ({
            ...el,
            renderName: (
              <div className={"d-flex align-content-center"} key={`${el.name}`}>
                <ColourChip colour={el.colour} />{" "}
                <span style={{ margin: "auto 0" }}>{el.name}</span>
              </div>
            ),
          })),
      );
    }
  }, [inSegment, showMyLists]);

  return (
    <>
      <SideSegment
        segment={segment}
        {...props}
        customOpts={customOpts}
        ops={["or", "not"]}
        onChange={onChange}
        actions={[
          <CFormSwitch
            label={"Show My My Lists"}
            onChange={() => setShowMyLists(!showMyLists)}
            checked={showMyLists}
          />,
        ]}
      ></SideSegment>
    </>
  );
};

export default UserList;
